import PropTypes from "prop-types";

const HelpText = ({ id, text, error = null, customHelpTextStyle = {} }) => (
  <div
    id={`${id}${error ? `error` : "helper-text"}`}
    aria-label={`${id}${error ? `error` : "helper-text"}`}
    className={`text-left text-xs-1  font-normal tracking-caption leading-subhead ${
      error ? "text-color-brick" : " text-opacity-87"
    } ${customHelpTextStyle}`}
  >
    {text}
  </div>
);

HelpText.propTypes = {
  /** identifier for helper text and associated field*/
  id: PropTypes.string.isRequired,
  /** display helper text for component */
  text: PropTypes.string.isRequired,
  /** highlights text in red if error is true*/
  error: PropTypes.bool,
  /** optional string used to add additional style to HelpText field */
  customHelpTextStyle: PropTypes.string,
};

export default HelpText;
